/**
 * QRMaps Design System - Shadow Tokens
 *
 * Box shadow definitions for elevation and depth
 * Based on values found in MainMap.js and other components
 */

export const shadows = {
  none: 'none',

  // Elevation levels
  sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
  md: '0 2px 6px rgba(0, 0, 0, 0.3)',  // Used in geolocation button
  lg: '0 4px 12px rgba(0, 0, 0, 0.4)',
  xl: '0 8px 24px rgba(0, 0, 0, 0.5)',
  xxl: '0 12px 32px rgba(0, 0, 0, 0.6)',

  // Specialized shadows
  card: '0 2px 8px rgba(0, 0, 0, 0.15)',
  modal: '0 8px 24px rgba(0, 0, 0, 0.4)',
  dropdown: '0 4px 16px rgba(0, 0, 0, 0.2)',

  // Inner shadow
  inset: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
};